import { render, staticRenderFns } from "./KButtonRadio.vue?vue&type=template&id=70d1d352&lang=pug"
import script from "./KButtonRadio.vue?vue&type=script&lang=js"
export * from "./KButtonRadio.vue?vue&type=script&lang=js"
import style0 from "./KButtonRadio.vue?vue&type=style&index=0&id=70d1d352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports